import { X, CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react';
import { useNotificationStore } from '../../stores/notificationStore';

const iconMap = {
  success: <CheckCircle size={16} color="var(--green)" />,
  error:   <AlertCircle size={16} color="var(--red)" />,
  warning: <AlertTriangle size={16} color="var(--amber)" />,
  info:    <Info size={16} color="var(--blue)" />,
};

const toastClass: Record<string, string> = {
  success: 'toast toast-success',
  error:   'toast toast-error',
  warning: 'toast',
  info:    'toast toast-info',
};

export function ToastContainer() {
  const { toasts, removeToast } = useNotificationStore();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={toastClass[t.type] ?? 'toast'}>
          <span style={{ flexShrink: 0 }}>{iconMap[t.type]}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 500 }}>{t.title}</div>
            {t.description && (
              <div style={{ fontSize: 12, opacity: 0.8, marginTop: 2 }}>{t.description}</div>
            )}
          </div>
          <button
            onClick={() => removeToast(t.id)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', opacity: 0.6, flexShrink: 0, display: 'flex' }}
            onMouseEnter={e => ((e.currentTarget as HTMLElement).style.opacity = '1')}
            onMouseLeave={e => ((e.currentTarget as HTMLElement).style.opacity = '0.6')}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
